export default __webpack_public_path__ + "static/media/max-kleinen-fg23HeRx4-k-unsplash.4fcd0a37.jpg";